import React from 'react';
const Loader = () => {
  return (
    <div className="custom-loading-overlay">
      <div className="custom-loading-image"></div>
    </div>
  );
};
export default Loader;
